import React from "react";
import { Modal, ModalBody, Spinner } from "reactstrap";

interface BlockUserModalProps {
  show?: string;
  onConfirmClick?: () => void;
  onCloseClick?: () => void;
  recordId?: string;
  loading?: boolean;
  action?: string;
}

const BlockUserModal: React.FC<BlockUserModalProps> = ({
  show,
  onConfirmClick,
  onCloseClick,
  recordId,
  loading,
  action,
}) => {
  return (
    <Modal
      fade={true}
      isOpen={show ? true : false}
      toggle={onCloseClick}
      centered={true}
    >
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          <i
            className={
              action === "activate"
                ? "ri-shield-check-fill display-5 text-success"
                : "ri-shield-cross-fill display-5 text-danger"
            }
          ></i>
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you sure ?</h4>
            <p className="text-muted mx-4 mb-0">
              Are you sure you want to {action} this user{" "}
              {recordId ? recordId : ""} ?
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light material-shadow-none"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Close
          </button>
          <button
            type="button"
            className="btn w-sm btn-danger material-shadow-none"
            id="process-record"
            onClick={onConfirmClick}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner
                  color="light"
                  size="sm"
                  style={{ marginRight: "8px", marginBottom: "-1px" }}
                ></Spinner>{" "}
                Processing...
              </>
            ) : (
              "Yes, Continue!"
            )}
          </button>
        </div>
      </ModalBody>
    </Modal>
  ) as unknown as JSX.Element;
};

export default BlockUserModal;
